module.exports = __webpack_public_path__ + "82514c4d3303395d32a4c0d878b60a32.png";